<template>
    <div v-if="itsEnvia && itsWeb">
        <ui-card class="tracking-card" :shadow="false">
            <div>
                <p class="tracking-card__text">{{ $t('Track your shipments with Envia.com') }}</p>
                <div class="tracking-card__content">
                    <ui-input
                        id="trackings"
                        name="trackings"
                        type="text"
                        v-model="formData.tracking"
                        class="mr-2 tracking-input"
                        :placeholder="$t('Enter your tracking number')"
                    />
                    <ui-button @click="track" variant="primary" class="tracking-card__button">{{ $t('Track') }}</ui-button>
                </div>
            </div>
        </ui-card>
    </div>
</template>

<script>
import UiCard from '@/components/ui/Card.vue';
import UiInput from '@/components/ui/inputs/Input.vue';
import UiButton from '@/components/ui/buttons/Button.vue';
import WebMixin from '@/plugins/mixin/web.mixin';
import { mapGetters } from 'vuex';


export default {
    name: 'TrackingModule',
    mixins: [WebMixin],
    components: {
        UiCard,
        UiInput,
        UiButton,
    },
    data() {
        return {
            formData: {
                tracking: '',
            },
        };
    },
    computed: {
        ...mapGetters('ui', ['sites', 'language']),
        itsEnvia() {
            const { site_id } = this.$route.query;
            const envia = this.sites.find(site => site.name.toLowerCase() === 'envia');

            if (envia && site_id) {
                return site_id === envia?.site_id;
            }

            return false;
        },
        itsWeb() {
            if (this.itsWebVersion) {
                return true;
            }
        },
    },
    methods: {
        async track() {
            const { tracking } = this.formData;
            if (!tracking) return;

            const url = `${window.ENV.VUE_APP_LANDING_ENVIA_URL}/${this.language}/${this.$t('tracking')}?label=${tracking}`;
            window.open(url, '_blank');
        },
    },
}
</script>

<style lang="scss">
.tracking-card {
    background-color: #000B48;
    border-radius: 8px;
    width: 591px;
    height: auto;
    padding: 24px 16px;
    gap: 8px;
    border: 1px solid #E9E9E9;

    @media(max-width: 1200px) {
        width: 100%;
        height: auto;
    }

    @media (max-width: 768px) {
        width: 100%;
        height: auto;
        
    }

    &__text {
        color: #f7f7f7;
        font-size: 18px;
        line-height: 21.94px;
        width: 377px;
        height: 22px;

        @media (max-width: 768px) {
            width: 100%;
            height: auto;
        }
    }

    &__content {
        display: flex;
    }

    &__button {
        background-color: $envia-accent !important;
        border-color: $envia-accent !important;


        &:hover {
            background-color: $envia-secondary !important;
            color: $envia-accent !important;
            border-color: $envia-secondary !important;
        }
    }    
}

.tracking-input {
    flex-grow: 1;

    @media (max-width: 768px) {
        width: 100%;
    }
}
</style>